var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrochip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:7.9px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.22,80.86h14.9m-14.9,19.39h14.9m-14.9,19.41h14.9m-14.9,19.4h14.9M44,80.86H58.86M44,100.25H58.86M44,119.66H58.86M44,139.06H58.86m78.89,21v15M118.5,160v15M99.25,160v15M80,160v15m57.74-130.2v15m-19.25-15v15m-19.25-15v15M80,44.86v15m55,85.74H82.8a8.44,8.44,0,0,1-8.38-8.44V84.6a8.44,8.44,0,0,1,8.38-8.45H135a8.44,8.44,0,0,1,8.38,8.45v52.58A8.44,8.44,0,0,1,135,145.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrochip);
export default __webpack_public_path__ + "static/media/MICROCHIP.f3acfcc3b0e0f3c0e0718b710691b7ff.svg";
export { ForwardRef as ReactComponent };